import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { TableContext } from '../../../components/Table/TableContext';
import TierShape from './TierShape';

const propTypes = {
  tier: TierShape,
  index: PropTypes.number,
};
const defaultProps = {
  tier: null,
  index: undefined,
};

export default function TierRowItem({
  tier: { id, name, title, description, allowedTemplates, allowedBlocks },
  index,
}) {
  const { onClickEdit, onClickDelete, formatContentBlocksLabel } =
    useContext(TableContext);

  const handleClickEdit = () => onClickEdit(id);
  const handleClickDelete = () => onClickDelete(id);

  return (
    <tr key={`${id}-${index.toString()}`}>
      <td>{name}</td>
      <td>{title}</td>
      <td>{description}</td>
      <td>{allowedTemplates.map((t) => `${t.toString()}`).join(', ')}</td>
      <td>{formatContentBlocksLabel(allowedBlocks)}</td>
      <td className="p-1">
        <div className="flex space-around space-between text-center">
          <Button
            className="p-1 me-1 text-dark"
            variant="link"
            onClick={handleClickEdit}
            title="Edit tier"
            role='button'
            aria-label='Edit Tier'
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </Button>
          <Button
            className="p-1 text-dark"
            variant="link"
            onClick={handleClickDelete}
            title="Delete tier"
            role='button'
            aria-label='Delete Tier'
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      </td>
    </tr>
  );
}

TierRowItem.propTypes = propTypes;
TierRowItem.defaultProps = defaultProps;
